export const consentOptions = [
  {
    key: "GOL",
    text: "GOL",
  },
  {
    key: "ARGOS",
    text: "Argos",
  },
  {
    key: "TU",
    text: "TU",
  },
  {
    key: "BANK",
    text: "Sainsbury's Bank",
  },
  {
    key: "AFS",
    text: "Argos Financial Services",
  },
  {
    key: "HABITAT",
    text: "Habitat",
  },
];
